import api from './api';

export const getMilestones = async (params = {}) => {
  const response = await api.get('/configuration/milestones', { params });
  return response.data;
};

export const getMilestone = async (id) => {
  const response = await api.get(`/configuration/milestones/${id}`);
  return response.data;
};

export const createMilestone = async (data) => {
  const response = await api.post('/configuration/milestones', data);
  return response.data;
};

export const updateMilestone = async (id, data) => {
  const response = await api.put(`/configuration/milestones/${id}`, data);
  return response.data;
};

export const deleteMilestone = async (id) => {
  const response = await api.delete(`/configuration/milestones/${id}`);
  return response.data;
};
